import { useEffect } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import "@/App.css";
import Hero from "@/components/landing/Hero";
import Marquee from "@/components/landing/Marquee";
import Included from "@/components/landing/Included";
import Trust from "@/components/landing/Trust";
import FinalCTA from "@/components/landing/FinalCTA";
import { captureUtm } from "@/lib/utm";

function App() {
  useEffect(() => {
    captureUtm();
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="bg-[#F9F8F6] text-[#111111] antialiased overflow-x-clip">
      <Toaster position="top-center" richColors />
      <Hero />
      <Marquee />
      <Included />
      <Trust />
      <FinalCTA />
      <footer className="bg-[#111111] text-[#F9F8F6]/40 text-xs tracking-[0.15em] uppercase px-6 py-8 flex flex-col sm:flex-row gap-2 justify-between">
        <span>© 2026 Agency HQ</span>
        <span>$250/month · No lock-in · No startup fees</span>
      </footer>
    </div>
  );
}

export default App;
